// extracted by mini-css-extract-plugin
export var closeButton = "_lu-1";
export var closeX = "_lu-3";
export var container = "_lu-0";
export var image = "_lu-2";